import { render, staticRenderFns } from "./IbInput.vue?vue&type=template&id=1a3cfdb6"
import script from "./IbInput.vue?vue&type=script&lang=js"
export * from "./IbInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports